import { KoncentroValidators } from './../../../../../modules/UIKit/validators/koncentro-validators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-update-personal-data-form',
  templateUrl: './update-personal-data-form.component.html',
  styleUrls: ['./update-personal-data-form.component.css']
})
export class UpdatePersonalDataFormComponent implements OnInit {
  updatePersonalDataForm: FormGroup;
  invalidSubmit = false;
  @Input() customerEmail: string = '';
  @Input() customerPhone: string = '';
  @Output() personalDataUpdated: EventEmitter<any> = new EventEmitter();

  constructor(
    private giftService: LoyaltyGiftReservationService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    //federico5    
    this.updatePersonalDataForm = this.fb.group({
      email: [this.customerEmail],
      phone: [this.customerPhone]
    });
    this.updateValidators();
  }

  /**
   * Setta dinamicamente i validator dei campi del form.
   * Creata per permettere la validazione anche con un solo campo compilato
   */
  updateValidators() {
    this.updatePersonalDataForm.get('email').clearValidators();
    this.updatePersonalDataForm.get('email').updateValueAndValidity();
    this.updatePersonalDataForm.get('phone').clearValidators();
    this.updatePersonalDataForm.get('phone').updateValueAndValidity();
    // Almeno uno dei due campi deve essere valorizzato
    if (!this.updatePersonalDataForm.get('email').value && !this.updatePersonalDataForm.get('phone').value) {
      this.updatePersonalDataForm.get('email').setValidators([Validators.required, Validators.email]);
      this.updatePersonalDataForm.get('email').updateValueAndValidity();
      this.updatePersonalDataForm.get('phone').setValidators([Validators.required, KoncentroValidators.phone_mg]);
      this.updatePersonalDataForm.get('phone').updateValueAndValidity();
    }
    if (this.updatePersonalDataForm.get('email').value) {
      this.updatePersonalDataForm.get('email').setValidators(Validators.email);
      this.updatePersonalDataForm.get('email').updateValueAndValidity();
    }
    if (this.updatePersonalDataForm.get('phone').value) {
      this.updatePersonalDataForm.get('phone').setValidators(KoncentroValidators.phone_mg);
      this.updatePersonalDataForm.get('phone').updateValueAndValidity();
    }
  }

  savePersonalData() {
    this.updateValidators();
    if (!this.updatePersonalDataForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const email = this.updatePersonalDataForm.get('email').value;
    const phone = this.updatePersonalDataForm.get('phone').value;
    this.giftService.editCustomerEmailAndMobile(email, phone).subscribe(() => this.personalDataUpdated.emit());
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/confirm-gift-reservation-form/update-personal-data-form/update-personal-data-form.component.ts